import { OmitStrict } from 'type-zoo/types';

import { ButtonProps } from '@dansk-metal/ui';

import { EventDto } from '@web/services/crm-api/rest';

import { ContentDrawer, ContentDrawerProps } from '../content-drawer/content-drawer';

import { EventCancellationConfirmation } from './event-cancellation-confirmation';
import { EventCancellationForm } from './event-cancellation-form';

export type EventCancellationDrawerProps = {
	drawer: OmitStrict<ContentDrawerProps, 'children'>;
	onSubmit: () => Promise<void>;
	event: EventDto;
	shouldShowConfirmation: boolean;
};

export function EventCancellationDrawer({ shouldShowConfirmation, onSubmit, drawer, event }: EventCancellationDrawerProps) {
	const onSubmitHandler = async () => {
		try {
			await onSubmit();
		} catch (error) {
			console.error(error);
		}
	};

	return (
		<ContentDrawer {...drawer}>
			{shouldShowConfirmation ? (
				<EventCancellationConfirmation event={event} onClose={drawer.onClose as ButtonProps['onClick']} />
			) : (
				<EventCancellationForm onSubmit={onSubmitHandler} event={event} />
			)}
		</ContentDrawer>
	);
}
